export enum DeviceType {
    Desktop = 'desktop',
    Mobile = 'mobile',
}